








































import { Component, Vue } from 'vue-property-decorator'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Hamburger from '@/components/Hamburger.vue'
import { SidebarType } from '@/store/modules/layout'
import { namespace } from 'vuex-class'

const appModule = namespace('app')
const layoutModule = namespace('layout')

@Component({ components: { Breadcrumb, Hamburger } })
export default class Navbar extends Vue {
  @appModule.Action logout!: () => void
  @layoutModule.State sidebar!: SidebarType
  @layoutModule.Action('toggleSidebar') doToggleSidebar !: (withoutAnimation: boolean) => void

  toggleSidebar() {
    this.doToggleSidebar(false)
  }
}
